import { SVGProps, Ref, forwardRef } from 'react';

export const ENSize16Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <rect y={2} width={16} height={12} rx={2} fill="#22408C" />
            <path
                d="M6.08 5.06 2 2A2 2 0 0 0 .053 3.54L3.44 6.08H0v3.84h3.44L.053 12.46A2 2 0 0 0 2 14l4.08-3.06V14h3.84v-3.06L14 14a2 2 0 0 0 1.947-1.54L12.56 9.92H16V6.08h-3.44l3.387-2.54A2 2 0 0 0 14 2L9.92 5.06V2H6.08z"
                fill="#EEEEEE"
            />
            <path d="m15.387 2.56-4.694 3.52H9.92v-.62l4.542-3.406c.354.083.672.261.925.505" fill="#CF1B2B" />
            <path d="M.158 3.219 3.973 6.08h1.6L.735 2.451c-.25.204-.449.467-.577.768" fill="#CF1B2B" />
            <path d="M6.08 9.92v.62l-4.542 3.406a2 2 0 0 1-.925-.505L5.307 9.92z" fill="#CF1B2B" />
            <path d="M15.265 13.549c.25-.204.449-.467.577-.768L12.027 9.92h-1.6z" fill="#CF1B2B" />
            <path d="M9.2 9.2V14H6.8V9.2H0V6.8h6.8V2h2.4v4.8H16v2.4z" fill="#CF1B2B" />
        </g>
    </svg>
));
ENSize16Glyph.displayName = 'ENSize16Glyph';
